import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Consulta } from 'src/core/consulta/consulta.types';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TestbackendService {

  apiUrl = environment.BASE_URL;

  constructor(private _httpClient: HttpClient) { }

  getConsultas(): Observable<Consulta[]>
  {
      return this._httpClient.get<Consulta[]>('http://localhost:8081/suscriptor/consultas');
  }
}
